module.exports = __webpack_public_path__ + "img/img3.0193884f.jpg";